import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useState} from "react";
import {formatCurrency} from "../../common/Utils";
import {Card, Chip, Divider, Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import Avatar from "@mui/material/Avatar";
import {People} from "@mui/icons-material";
import InventoryModalBody from "../modal/InventoryModalBody";
import {CardBody, CardTitle, Col, Row} from "react-bootstrap";
import {addToCart} from "../../common/api/PortalCustomerApi";

export default function ClientCartInventoryEventMemberships({cartItem, memberships, handleSave}) {
  const [context, setContext] = useContext(AppContext);

  const loadCartFn = () => {

    let _context = {...context};
    _context.reloadCart = true;
    _context.toast = {
      message: 'Added to cart!',
      type: 'success'
    }
    setContext({..._context});
  };

  const [viewInventory, setViewInventory] = useState(false);
  const [inventory, setInventory] = useState();
  const viewInventoryItem = (inventory) => {
    setInventory(inventory);
    setViewInventory(true);
  }

  const addToCartFn = async (inventory) => {
    addToCart(inventory).then(resp => {
      handleSave(resp);
    })
  };

  return (
    <>
    {viewInventory && <>
      <Card>
        <CardTitle>
          <Row>
            <Col xs={12}>
              <MDButton
                onClick={() => {
                  setViewInventory(false);
                }}
                style={{
                  float: 'right'
                }}>Back</MDButton>
            </Col>
          </Row>
        </CardTitle>
        <CardBody>
          <InventoryModalBody
            addToCart={addToCartFn}
            inventory={inventory}/>
        </CardBody>
      </Card>
    </>}
      {!viewInventory && <MDBox p={3}>
        <MDBox>
          {memberships?.length > 0 && <>
            {memberships?.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
              // .filter(item => showEvent(item))
              .map((inventory, index) => {
                return (
                  <div key={index}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={9}>
                        <h6>{inventory.name}</h6>
                        <p><small>
                          {inventory.accountType?.name}
                        </small><br/>
                          <small
                            className={inventory?.accountType?.siblingOptionsEnabled ? 'text-decoration-line-through' : ''}>
                            {formatCurrency(inventory?.price)}
                          </small>
                          {inventory?.accountType?.siblingOptionsEnabled && <small>
                            <br/>
                            {formatCurrency(inventory.discountPrice)}
                          </small>}
                        </p>
                        {inventory?.siblingMembership && <><Chip
                          icon={<People/>}
                          label={'Sibling Rate ' + formatCurrency(inventory?.siblingMembership?.price)}
                          variant="outlined"
                          color="secondary"/>
                          &nbsp;
                        </>}
                        <p>
                          <small>
                            {inventory.desc}
                          </small>
                        </p>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <MDBox display="flex" justifyContent="flex-end">
                          <Avatar alt={inventory?.name}
                                  className={'pull-left m-3'}
                                  sx={{width: 96, height: 96}}>
                            {inventory?.imageUrl && <img src={inventory?.imageThumbUrl || inventory?.imageUrl}
                                                         style={{width: '200%', height: 'auto'}}
                                                         alt={inventory?.name}/>}
                          </Avatar>
                        </MDBox>
                        {
                          <MDBox display="flex" justifyContent="flex-end">
                            <MDButton
                              size={'small'}
                              color="primary"
                              onClick={(e) => {
                                viewInventoryItem(inventory);
                              }}>View Details</MDButton>
                          </MDBox>
                        }
                      </Grid>
                    </Grid>
                    <Divider/>
                  </div>
                )
              })
            }
          </>}
        </MDBox>
      </MDBox>
      }
    </>
  )
}